import { CollectionChainType } from '../common';

export function getChainFromIndex(chainIndex: 0 | 1 | 2) {
    switch (chainIndex) {
        case 2:
            return CollectionChainType.Aptos;
        case 1:
            return CollectionChainType.Polygon;
        case 0:
        default:
            return CollectionChainType.Ethereum;
    }
}
